export const loadingConstants = {
  LOADING_ON: 'LOADING_ON',
  LOADING_OFF: 'LOADING_OFF',
};
